/**
 * CZNA-1125 — "a blank heading is saveable but must be visible", said at the
 * field rather than as a server banner.
 *
 * <p>The backend gate (`HeadingBlankValidator`) already warns on a draft save
 * and blocks submit-for-review/publish. This component is the frontend half of
 * "the cataloguer sees the message" (bullet 3): it re-reads the SAME live
 * `headingValue` `RecordForm` already shows as the pane title (composed by the
 * backend since CZNA-1418, `useHeadingPreview`) — no new client-side rule, just a visible reaction to one that already exists — and
 * reuses the existing `proposalForm.validation.mainHeadingRequired` copy
 * instead of inventing new wording (bullet 3's other half).
 *
 * <p>Purely advisory: rendering it never disables Save (CZNA-582 — a draft
 * save is never blocked, only reported), it only makes the same fact visible
 * before the cataloguer reaches the submit/publish gate that does refuse.
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon } from '@folio/stripes/components';
var rowStyle = {
    display: 'flex',
    alignItems: 'baseline',
    gap: '0.5rem',
    padding: '0.25rem 0 0.25rem 0',
};
var HeadingRequiredHint = function (_a) {
    var headingValue = _a.headingValue;
    if (headingValue.trim() !== '')
        return null;
    return (React.createElement("div", { style: rowStyle, "data-test-heading-required-hint": true },
        React.createElement(Icon, { icon: "info", size: "small", status: "warn" }),
        React.createElement("span", null,
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposalForm.validation.mainHeadingRequired" }))));
};
export default HeadingRequiredHint;
